import { Children, FunctionComponent } from 'react'
import Menu from '@material-ui/core/Menu'
import { useCurrentTarget } from 'hooks/use-current-target/useCurrentTarget'
import { MenuItem, IconButton, Box, Badge } from '@material-ui/core'
import styled from 'styled-components/macro'
import { lighten } from 'polished'
import { ActionContextMenuItem } from './ActionContextMenu'
import './style.css';
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'

import profileState from 'models/profile-store/profile.store'
import { observer } from 'mobx-react'

type Variant = 'primary' | 'danger' | 'disabled'

interface NavbarDropdownMenuProps {
  title?: string
  icon: any
  menuItems?: ActionContextMenuItem[]
  showCounterBadge?: boolean
  counterValue?: number
}

const getVariantColor = (variant: Variant, props: any) => {
  switch (variant) {
    case 'primary': {
      return props.theme.colors.primary
    }
    case 'danger': {
      return props.theme.colors.error
    }
    case 'disabled': {
      return props.theme.colors.accent
    }
  }
}
const MainMenu = styled(Menu)`
.MuiPaper-root,
.MuiMenu-paper,
.MuiPopover-paper,
.MuiPaper-elevation8,
.MuiPaper-rounded{
  border-radius: 0.9375em;
  margin: 4.1em -0.6em;
  width: 20em;
  top: 1em !important;
}
`
const StyledMenuItem = styled(MenuItem)<{ first?: boolean; last?: boolean; variant: Variant }>`
  color: ${props => getVariantColor(props.variant, props)} !important;
  border-bottom: 1px solid ${props => (!props.last ? lighten(0.25, props.theme.colors.accent) : 'none')} !important;
`

const NavbarDropdownMenuObserver: FunctionComponent<NavbarDropdownMenuProps> = ({
  showCounterBadge,
  counterValue,
  icon,
  menuItems,
  children
}) => {
  const { anchorEl, handleCustomEventClick, handleReset } = useCurrentTarget()
  const { isDevice } = useScreenSizes()

  return (
    <Box className="dropdown-wrapper">
      <IconButton style={{padding: isDevice ? '0':'0 0 0 12px'}} onClick={e => handleCustomEventClick(e)}  className="dropdown-wrapper__button">
        {!showCounterBadge && icon}
        {showCounterBadge && (
          <Badge badgeContent={counterValue} variant="standard" color="primary">
            {icon}
          </Badge>
        )}
      </IconButton>
      <MainMenu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          handleReset()
          profileState.setisMenuOpen(!profileState.isMenuOpen)
        }}
        keepMounted
        style={{height: isDevice ? '40em' : ''}}
      >
        {Children.map(children, (x, i) => {
          return x === null ? null : (
            <Box onClick={() => {
              profileState.setisMenuOpen(!profileState.isMenuOpen)
            }}
            key={i}
            width='100%'
            >
              {x}
            </Box>
          )
        })}
        {menuItems &&
          menuItems.map(item => {
            return (
              <StyledMenuItem
                onClick={() => {
                  if (item.variant !== 'disabled') {
                    item.action()
                  }
                  handleReset()
                }}
                variant={item.variant}
                first={menuItems.indexOf(item) === 0}
                last={menuItems.indexOf(item) === menuItems.length - 1}
              >
                {item.label}
              </StyledMenuItem>
            )
          })}
      </MainMenu>
    </Box>
  )
}

export const NavbarDropdownMenu = observer(NavbarDropdownMenuObserver)